<section class="cui-dialog preview-dialog">
  <header class="cui-dialog__header preview-header">
    <h1>{{ file.name }}</h1>
    <cui-dialog-close-button />
  </header>

  <div class="cui-dialog__content preview-content">
    @if (file.mimeType.startsWith('image/')) {
      @if (previewUrl(); as url) {
        <img class="preview-image" [src]="url" [alt]="file.name" />
      } @else {
        <span class="material-symbols-outlined preview-icon" aria-label="Loading image preview">
          image
        </span>
      }
    } @else {
      <div class="preview-file">
        <span class="material-symbols-outlined preview-icon" aria-hidden="true">description</span>
        <span class="preview-file-name">{{ file.name }}</span>
      </div>
    }
  </div>

  <footer class="cui-dialog__actions preview-actions">
    <button cuiButton type="button" (click)="download()">
      <span class="material-symbols-outlined" aria-hidden="true">download</span>
      Download
    </button>
  </footer>
</section>
